// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SM3sydB6sYypLxcXUI4w{
    width: 100%;
    background-color: #F5F5F5;
    display: flex;
    flex-direction: column;
}
.F5VhilzizFBb_RfUkZpT{
    background-color: #F5F5F5;
}
.SM3sydB6sYypLxcXUI4w::-webkit-scrollbar {
    display: none;
}
.o8_Q50oAhFIyjLO9A_gN {
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 20px;
    padding: 6px 12px;
    font-size: 12px;
    gap: 5px;
    border-radius: 20px;
    background-color: white;
    border: none;
}
.dfnjd0GwCO75NgkgborT{
    position: absolute;
    top: 40%;
    left: 45%;
    transform: translate(-50%, -50%);
}
.TBRm51tCdrVe_nggv7xx{
    font-weight: bold;
    font-size: 16px;
    color: #1a73e8;
}
.AL67M9D_Ja9H4G4QphoV{
    font-size: 14px;
    color: #666;
}
.NMr7olvyK_gMAoyseqiC{
    font-weight: bold;
    font-size: 14px;
}
.mi2n15sUsiA7UyiEkUtW{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
    color: white;
    margin-right: 10px;
}
.FJBqk3tpihkw8iBeHS6G{
    height: 65vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
}
.FcItI3_QBwl3q3o19jY4 {
    display: flex;
    flex-direction: column;
}
.rT88ZPmLzQIUIWpgAo8D {
    font-weight: bold;
    font-size: 14px;
    color: #333;
    line-height: 1.2;
}
.fq5hhk_gayhkvpL2P7y_ {
    display: flex;
    align-items: center;
    gap: 10px;
}
.SQwUlz3eKEL6SLiSr3LW {
    font-size: 12px;
    color: #888;
    line-height: 1.2;
}
.LUc7av1yviB8wylL5KLU {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}
.T6_MzHrONOuk4yCCZn61,.wc2wNeSYxGDfePoPXTJs {
    display: flex;
    padding: 7px 5px;
    font-size: 10px;
    align-items: center;
    justify-content: center;
    width: 60px;
    background-color: #004BA0;
    height: 10px;
    border: none;
    color: white;
    border-radius: 20px;
    cursor: pointer;
}
.eH8zVIsThAz0pXpqRoip {
    display: flex;
    align-items: center;
}
.qmMax4tIw0B_b_89Bmzd{
    width: 100%;
    background-color: white;
    padding: 5px 10px;
    border-radius: 15px;
    position: relative;
}
.rSVKc4uOOAPgp3lDvCne {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.aWBhp5PKh9s7LHQfHi3B{
    background-color: #F5F5F5;
    height: 20px;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
}
.gBd7d9hDrwMCoSbiIopT{
    text-align: center;
}
.Pw4Xa8CbqJFi1Gj2Dmn6{
    background-color: #46A24A;
    border-radius: 40px;
    height: 30px;
    width: 100px;
}
.F3m1uTOHQtzQyMEE4iOj{
    display: flex;
    gap: 10px;
    color: white;
    padding: 10px;
    align-items: center;
    position: absolute;
    top: -20px;
}

/*mobile view*/
@media screen and (max-width: 600px) {
    .j1vqPwpafT9dEPxUBEkB {
        cursor: pointer;
        height: 37px;
        margin-left: 5px;
    }
    .ezMxxHM3VkP04H8cC6rs {
        margin-left: 40px;
        height: 40px;

    }
    .uBgSSzRXXJ4YVDtknaz5 {
        min-height: 100vh;
        padding: 15px;
    }
    .m9ZXG3JVxD_99bT9dz9e {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
    }
    .hc_oJQmRs6MYmtzM8SBE {
        width: 20px;
        color: white;
        background-color: white;
        padding: 7px 7px 3px 7px;
        border: 0 solid white;
        border-radius: 16px;
        cursor: pointer;
    }
    .TBRm51tCdrVe_nggv7xx {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        font-family: Nunito Sans, Sans-serif, serif;
        margin-top: 30px;
    }
    .QBV3pMneUruur2828kM_ {
        margin-top: 30px;
    }
    .C_I1xdOCTaptLrUfEcJA {
        background-color: #007bff;
        color: #fff;
        border: none;
        padding: 10px 20px;
        font-size: 16px;
        cursor: pointer;
        margin: 20px 0;
        border-radius: 5px;
    }
    .NMr7olvyK_gMAoyseqiC {
        font-size: 20px;
        font-weight: bold;
        color: #333;
    }
    .pBVWcp1FB0CvZi3BIiUQ {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-top:-11px;
        margin-left:-14rem;
    }
    .wdJRcMMdFkb6XtE4Dshl {
        text-align: center;
        margin-top: 20px;
        color: #888;
    }
    .xzBtJWxMeTs6bz9czOAd {
        position: relative;
        margin: 15px 0;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 8px;
        background-color: #f9f9f9;
    }
    .wQAYHfxReDi79DwdvePz{
        text-align: center;
        position: absolute;
        top: 30px;
        right: 10px;
        width: 30%;
        color: #888;
        background-color: #f9f9f9;
    }
    .lmZVCyaVKAjjtSsdWf0u {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }
    .mi2n15sUsiA7UyiEkUtW {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        color: white;
    }
    .FcItI3_QBwl3q3o19jY4 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 2px;
    }
    .BqU1uBUnnZRm0Bj4hd_g {
        font-size: 14px;
        color: rgba(77, 77, 77, 1);
        margin-top: 2px;
        font-weight: 400;
        font-family: 'Nunito Sans', Sans-serif, serif;
    }
    .kTff7HQ2fiQ6ZWSBWH5L {
        font-size: 16px;
    }
    .rT88ZPmLzQIUIWpgAo8D {
        font-weight: bold;
        color: #333;
        display: block;
    }
    .MWKmRQrT4OdPd8WkLfaX {
        font-size: 12px;
        color: #555;
        display: block;
    }
    .xzBtJWxMeTs6bz9czOAd p {
        color: #333;
        font-size: 14px;
    }
    .dgXrLxFVq2ZmAbCoK4c4 {
        width:28%;
        height:37px;
        margin-left:40%;
    }
    .cuoBUdebK61UFhnDKsdz {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: 41%;
    }
        .aItOMLyKwsWQosI1VxXn {
        font-size: 14px;
        color: #555;
    }

}
`, "",{"version":3,"sources":["webpack://./src/home/css/community-detailed.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,aAAa;IACb,SAAS;IACT,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA,cAAc;AACd;IACI;QACI,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,YAAY;;IAEhB;IACA;QACI,iBAAiB;QACjB,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,wBAAwB;QACxB,qBAAqB;QACrB,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,2CAA2C;QAC3C,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,eAAe;QACf,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,WAAW;IACf;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,cAAc;QACd,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,yBAAyB;IAC7B;IACA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,UAAU;QACV,WAAW;QACX,yBAAyB;IAC7B;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;IACA;QACI,eAAe;QACf,0BAA0B;QAC1B,eAAe;QACf,gBAAgB;QAChB,6CAA6C;IACjD;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,WAAW;QACX,cAAc;IAClB;IACA;QACI,eAAe;QACf,WAAW;QACX,cAAc;IAClB;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,SAAS;QACT,WAAW;QACX,eAAe;IACnB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,gBAAgB;IACpB;QACI;QACA,eAAe;QACf,WAAW;IACf;;AAEJ","sourcesContent":[".threadsContainer{\n    width: 100%;\n    background-color: #F5F5F5;\n    display: flex;\n    flex-direction: column;\n}\n.detailedContainer{\n    background-color: #F5F5F5;\n}\n.threadsContainer::-webkit-scrollbar {\n    display: none;\n}\n.copyLinkButton {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    height: 20px;\n    padding: 6px 12px;\n    font-size: 12px;\n    gap: 5px;\n    border-radius: 20px;\n    background-color: white;\n    border: none;\n}\n.loader{\n    position: absolute;\n    top: 40%;\n    left: 45%;\n    transform: translate(-50%, -50%);\n}\n.questionTitle{\n    font-weight: bold;\n    font-size: 16px;\n    color: #1a73e8;\n}\n.description{\n    font-size: 14px;\n    color: #666;\n}\n.answerLength{\n    font-weight: bold;\n    font-size: 14px;\n}\n.communityAvatar{\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 18px;\n    color: white;\n    margin-right: 10px;\n}\n.noResults{\n    height: 65vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 16px;\n    font-weight: bold;\n}\n.userInfo {\n    display: flex;\n    flex-direction: column;\n}\n.userName {\n    font-weight: bold;\n    font-size: 14px;\n    color: #333;\n    line-height: 1.2;\n}\n.dateContainer {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.communityDate {\n    font-size: 12px;\n    color: #888;\n    line-height: 1.2;\n}\n.editDeleteButtons {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n}\n.editButton,.deleteButton {\n    display: flex;\n    padding: 7px 5px;\n    font-size: 10px;\n    align-items: center;\n    justify-content: center;\n    width: 60px;\n    background-color: #004BA0;\n    height: 10px;\n    border: none;\n    color: white;\n    border-radius: 20px;\n    cursor: pointer;\n}\n.leftHeader {\n    display: flex;\n    align-items: center;\n}\n.answerCard{\n    width: 100%;\n    background-color: white;\n    padding: 5px 10px;\n    border-radius: 15px;\n    position: relative;\n}\n.answers {\n    font-size: 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n.answerCount{\n    background-color: #F5F5F5;\n    height: 20px;\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 12px;\n}\n.noAnswersMessage{\n    text-align: center;\n}\n.verifiedAnswer{\n    background-color: #46A24A;\n    border-radius: 40px;\n    height: 30px;\n    width: 100px;\n}\n.verify{\n    display: flex;\n    gap: 10px;\n    color: white;\n    padding: 10px;\n    align-items: center;\n    position: absolute;\n    top: -20px;\n}\n\n/*mobile view*/\n@media screen and (max-width: 600px) {\n    .backArrow {\n        cursor: pointer;\n        height: 37px;\n        margin-left: 5px;\n    }\n    .SHlogo {\n        margin-left: 40px;\n        height: 40px;\n\n    }\n    .detailedThreadContainer {\n        min-height: 100vh;\n        padding: 15px;\n    }\n    .questionContainer {\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 15px;\n    }\n    .shareIcon {\n        width: 20px;\n        color: white;\n        background-color: white;\n        padding: 7px 7px 3px 7px;\n        border: 0 solid white;\n        border-radius: 16px;\n        cursor: pointer;\n    }\n    .questionTitle {\n        font-size: 20px;\n        font-weight: bold;\n        color: #333;\n        font-family: Nunito Sans, Sans-serif, serif;\n        margin-top: 30px;\n    }\n    .answersSection {\n        margin-top: 30px;\n    }\n    .addAnswerButton {\n        background-color: #007bff;\n        color: #fff;\n        border: none;\n        padding: 10px 20px;\n        font-size: 16px;\n        cursor: pointer;\n        margin: 20px 0;\n        border-radius: 5px;\n    }\n    .answerLength {\n        font-size: 20px;\n        font-weight: bold;\n        color: #333;\n    }\n    .actions {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n        margin-top:-11px;\n        margin-left:-14rem;\n    }\n    .noAnswers {\n        text-align: center;\n        margin-top: 20px;\n        color: #888;\n    }\n    .answer {\n        position: relative;\n        margin: 15px 0;\n        padding: 10px;\n        border: 1px solid #ddd;\n        border-radius: 8px;\n        background-color: #f9f9f9;\n    }\n    .copiedText{\n        text-align: center;\n        position: absolute;\n        top: 30px;\n        right: 10px;\n        width: 30%;\n        color: #888;\n        background-color: #f9f9f9;\n    }\n    .answerHeader {\n        display: flex;\n        align-items: center;\n        margin-bottom: 10px;\n    }\n    .communityAvatar {\n        width: 45px;\n        height: 45px;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 16px;\n        font-weight: 700;\n        color: white;\n    }\n    .userInfo {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        gap: 2px;\n    }\n    .createdDate {\n        font-size: 14px;\n        color: rgba(77, 77, 77, 1);\n        margin-top: 2px;\n        font-weight: 400;\n        font-family: 'Nunito Sans', Sans-serif, serif;\n    }\n    .userInitial {\n        font-size: 16px;\n    }\n    .userName {\n        font-weight: bold;\n        color: #333;\n        display: block;\n    }\n    .answerDate {\n        font-size: 12px;\n        color: #555;\n        display: block;\n    }\n    .answer p {\n        color: #333;\n        font-size: 14px;\n    }\n    .verifiedBadge {\n        width:28%;\n        height:37px;\n        margin-left:40%;\n    }\n    .verifyCheckboxContainer {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        margin-left: 41%;\n    }\n        .verifyText {\n        font-size: 14px;\n        color: #555;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"threadsContainer": `SM3sydB6sYypLxcXUI4w`,
	"detailedContainer": `F5VhilzizFBb_RfUkZpT`,
	"copyLinkButton": `o8_Q50oAhFIyjLO9A_gN`,
	"loader": `dfnjd0GwCO75NgkgborT`,
	"questionTitle": `TBRm51tCdrVe_nggv7xx`,
	"description": `AL67M9D_Ja9H4G4QphoV`,
	"answerLength": `NMr7olvyK_gMAoyseqiC`,
	"communityAvatar": `mi2n15sUsiA7UyiEkUtW`,
	"noResults": `FJBqk3tpihkw8iBeHS6G`,
	"userInfo": `FcItI3_QBwl3q3o19jY4`,
	"userName": `rT88ZPmLzQIUIWpgAo8D`,
	"dateContainer": `fq5hhk_gayhkvpL2P7y_`,
	"communityDate": `SQwUlz3eKEL6SLiSr3LW`,
	"editDeleteButtons": `LUc7av1yviB8wylL5KLU`,
	"editButton": `T6_MzHrONOuk4yCCZn61`,
	"deleteButton": `wc2wNeSYxGDfePoPXTJs`,
	"leftHeader": `eH8zVIsThAz0pXpqRoip`,
	"answerCard": `qmMax4tIw0B_b_89Bmzd`,
	"answers": `rSVKc4uOOAPgp3lDvCne`,
	"answerCount": `aWBhp5PKh9s7LHQfHi3B`,
	"noAnswersMessage": `gBd7d9hDrwMCoSbiIopT`,
	"verifiedAnswer": `Pw4Xa8CbqJFi1Gj2Dmn6`,
	"verify": `F3m1uTOHQtzQyMEE4iOj`,
	"backArrow": `j1vqPwpafT9dEPxUBEkB`,
	"SHlogo": `ezMxxHM3VkP04H8cC6rs`,
	"detailedThreadContainer": `uBgSSzRXXJ4YVDtknaz5`,
	"questionContainer": `m9ZXG3JVxD_99bT9dz9e`,
	"shareIcon": `hc_oJQmRs6MYmtzM8SBE`,
	"answersSection": `QBV3pMneUruur2828kM_`,
	"addAnswerButton": `C_I1xdOCTaptLrUfEcJA`,
	"actions": `pBVWcp1FB0CvZi3BIiUQ`,
	"noAnswers": `wdJRcMMdFkb6XtE4Dshl`,
	"answer": `xzBtJWxMeTs6bz9czOAd`,
	"copiedText": `wQAYHfxReDi79DwdvePz`,
	"answerHeader": `lmZVCyaVKAjjtSsdWf0u`,
	"createdDate": `BqU1uBUnnZRm0Bj4hd_g`,
	"userInitial": `kTff7HQ2fiQ6ZWSBWH5L`,
	"answerDate": `MWKmRQrT4OdPd8WkLfaX`,
	"verifiedBadge": `dgXrLxFVq2ZmAbCoK4c4`,
	"verifyCheckboxContainer": `cuoBUdebK61UFhnDKsdz`,
	"verifyText": `aItOMLyKwsWQosI1VxXn`
};
export default ___CSS_LOADER_EXPORT___;
